import { useState } from "react";
import {
  Box, Tabs,
  Tab
} from "@mui/material";

import Reducing from "./Reducing";

export default function LoanSchedule() {
  const [value, setValue] = useState("basic");
  const [mode, setMode] = useState("basic"); // actual loan mode

  const handleTabChange = (event, newValue) => {
    if (newValue !== "interest-dropdown") {
      setValue(newValue);
      setMode(newValue);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        minHeight: "100vh",
      }}
    >
        <Box display="flex" alignItems="center" gap={2}>
          <Tabs
            value={value}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            sx={{ minHeight: 40 }}
          >
            <Tab
              value="basic"
              label="Reducing"
              sx={{ minHeight: 40, minWidth: 100 }}
            />
            <Tab
              value="flat"
              label="Flat"
              sx={{ minHeight: 40, minWidth: 100 }}
            />
            <Tab
              value="Interest"
              label="Interest Only"
              sx={{ minHeight: 40, minWidth: 100 }}
            />
            <Tab
              value="Bullet"
              label="Bullet"
              sx={{ minHeight: 40, minWidth: 100 }}
            />
            <Tab
              value="Subvention"
              label="Subvention"
              sx={{ minHeight: 40, minWidth: 100 }}
            />
          </Tabs>
        </Box>

        {(mode === "basic" || mode === "flat" || mode === 'Interest' || mode === "Bullet" || mode === "Subvention"  ) && (
          <Reducing mode={mode} />
        )}
        {/* {mode === "flat" && <Flat />} */}
        {/* {mode === "INTEREST" && <InterestMode />} */}
        {/* {mode === "Bullet" && <Bullets />}

        {mode === "Subvention" && <Subvention />} */}
    </div>
  );
}
